<div class="protean-group-list">
  <div class="row unselectable" style="width: 100%;">
    <div class="col-12 col-md-12">

      <!--Group Stats -->
      <div class="card stats-card" style="height:15vh;background-color: white;">
        <div class="widget-container group-stats" style="height: auto;">
          <div class="col-xs-3" style="border-radius: 30px;
          background-image: radial-gradient(#42cd0029,white);
          ">
            <div class="number color-blue" style="color: #0d7aff;">
              <div class="icon fa fa-globe"></div><span ng-bind="groups.length"
            style="font-size: 10mm;">{{groups.length}}</span>
          </div>
          <div class="text">{{"Total groups" | translate}}</div>
        </div>
          <div class="col-xs-3" style="border-radius: 30px;
          background-image: radial-gradient(#42cd0029,white);
          ">
          <div class="number color-green" style="color: #42cd00;">
            <div class="icon fa fa-play"></div><span ng-bind="activeGroups"
          style="font-size: 10mm;">{{activeGroups}}</span>
        </div>
        <div class="text">{{"Active groups" | translate}}</div>
      </div>
          <div class="col-xs-3" style="border-radius: 30px;
          background-image: radial-gradient(#ffa10129,white);
          ">
        <div class="number color-orange" style="color: #ffa101;">
          <div class="icon fa fa-pause"></div><span ng-bind="readyGroups"
        style="font-size: 10mm;">{{readyGroups}}</span>
      </div>
      <div class="text">{{"Ready groups" | translate}}</div>
    </div>
          <div class="col-xs-3" style="border-radius: 30px;
          background-image: radial-gradient(#ff52871c,white);
          ">
      <div class="number color-pink" style="color: #ff5287;">
        <div class="icon fa fa-stop"></div><span ng-bind="pendingGroups"
      style="font-size: 10mm;">{{pendingGroups}}</span>
    </div>
    <div class="text">{{"Pending groups" | translate}}</div>
  </div>
</div>
</div>

</div>
</div>

<div class="row unselectable" style="width: 100%;">
  <div class="col-12 col-md-12">

    <!--Group Quota Stats -->
    <div class="card stats-card" style="height: 70px;">
      <div class="widget-container group-quota-stats">
        <div class="col-xs-6">
          <div class="bar progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-{{numberBar.type}}"
              role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
              [ngStyle]="{'width': (numberBar.value!=null||numberBar.value!=undefined)? numberBar.value+'%' : '0%'}">
              <b [ngStyle]="{'position': numberBar.value>0?'relative':'absolute'}">{{numberBar.value}}%</b>
            </div>
          </div>
          <div class="text"> {{"Groups number use" | translate}}</div>
        </div>
        <div class="col-xs-6">
          <div class="bar progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-{{durationBar.type}}"
              role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"
              [ngStyle]="{'width': (durationBar.value!=null||durationBar.value!=undefined)? durationBar.value+'%' : '0%'}">
              <b [ngStyle]="{'position': durationBar.value>0?'relative':'absolute'}">{{durationBar.value}}%</b>
            </div>
          </div>
          <div class="text"> {{"Groups duration use" | translate}}</div>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="row unselectable" style="width: 100%;">
  <div class="col-12 col-md-12">

    <!--Group List -->
    <div class="card stats-card widget-container fluid-height group-list">
      <div class="heading">
        <!-- message="{{&quot;No Groups&quot; | }}"  -->
        @if (!groups.length) {
          <span icon="fa-object-group"></span>
        }
        @if (groups.length) {
          <div>
            <button type="button" class="btn btn-xs btn-primary-outline pull-right co-btn" data-bs-toggle="tooltip"
              data-bs-placement="top" title="Write an email to the group owner selection."
              [disabled]="filteredGroups.length" (click)="mailToGroupOwners()">
              <i class="fa fa-envelope-o"></i><span>&nbsp;{{"Contact Owners" | translate}}</span>
            </button>
            <div class="row form-inline">
              <div class="col-4 col-md-4 form-group group-list-header">
                <!-- <input type="text" class="form-control input-field" id="search-text" aria-describedby="search-text" [(ngModel)]="searchText" placeholder="Search Group" class="col-mg-3 m-2 float-right searchGroup" autofocus autocomplete="off">
                <select id="groupPage" [(ngModel)]="groupPageSize" style="font-size: 15px;">
                  <option *ngFor="let data of itemsPerPageOptions" value="{{data.value}}">{{data.name}}</option>
                </select>
                <protean-pager tooltip-label="{{'Group selection' | }}" total-items="filteredGroups.length" total-items-style="protean-pager-group-list-total-items" items-per-page="scopeGroupListCtrl.groupItemsPerPage" items-per-page-options="itemsPerPageOptions" current-page="scopeGroupListCtrl.groupCurrentPage" items-search="search"></protean-pager> -->
                <app-pagination [totalItems]="groups.length" [itemsPerPage]="groupPageSize" [itemsSearch]="searchText"
                  (searchedData)="onSearch($event)" (itemPerPageData)="onItemPerPageChange($event)"
                  (nextPageChange)="onNextPageChange($event)">
                </app-pagination>
              </div>
              <div class="col-2 col-md-2 form-group">
                <!-- <button type="button" class="btn btn-xs btn-primary-outline co-btn" (click)="mailToGroupOwners(filteredGroups)">
                <i class="fa fa-columns"></i><span>&nbsp;Customize</span>
              </button> -->
              <div class="protean-column-choice">
                <div class="btn-group" uib-dropdown="uib-dropdown" auto-close="outsideClick">
                  <button class="btn btn-xs btn-primary-outline co-btn"
                    style="cursor: pointer; --bs-btn-hover-bg: #2d6caa;" type="button"
                    (click)="showSubMenu(); $event.stopPropagation()">
                    <i class="fa fa-columns" style="cursor: pointer; --bs-btn-hover-bg: #2d6caa;"></i>
                    <span style="cursor: pointer; --bs-btn-hover-bg: #2d6caa;">&nbsp;{{"Customize" |
                    translate}}</span>
                  </button>
                  @if (showMenu) {
                    <ul class="dropdown-menu pointer protean-column-customize" role="menu"
                      (click)="$event.stopPropagation()" style="z-index: 1002;">
                      @for (column of groupData.columns; track column) {
                        <li>
                          <label class="checkbox pointer">
                            <input type="checkbox" [(ngModel)]="column.selected" /><span
                          class="checkbox-label">{{column.name}}</span>
                        </label>
                      </li>
                    }
                    <li>
                      <button class="btn btn-outline-danger btn-sm border-0 checkbox" (click)="resetData()"><i
                        class="fa fa-trash-o"></i><span>&nbsp;{{"Reset" | translate}}</span></button>
                      </li>
                    </ul>
                  }
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6 form-group pageStyle">
            <mat-paginator
              class="my-pagination"
              [hidden]="groups.length === 0"
              [length]="totalItems"
              [pageSize]="itemsPerPage"
              [pageIndex]="currentPage - 1"
              [pageSizeOptions]="[5, 10, 25, 50]"
              (page)="handlePageChange($event)">
            </mat-paginator>
            <protean-column-choice reset-data="resetData()" column-data="groupData.columns"></protean-column-choice>
          </div> -->
        </div>
      </div>
    }
    <div class="row">
      <div class="col-12 col-md-12">
        <div
          style="height: 37em; font-size: 13px; margin: 1rem; overflow: auto; scrollbar-width: thin; box-shadow: 2px 2px 8px;">
          <table class="table table-striped table-responsive">

            <thead class="thead-light">
              @if (groups.length == 0) {
                <tr>
                  <th colspan="12" class="text-center info-label">{{"No details to display..." | translate}}</th>
                </tr>
              }
              @if (groups.length != 0) {
                <tr>
                  <!-- for sort  -->
                  <!-- | sort : [sortparam,sortDirection] after columns -->
                  @for (column of groupData.columns ; track column; let i = $index) {
                    @if (column.selected) {
                      <th class="header sortable" (click)="sortBy(groupData, column)">
                        <div class="strong"
                          [ngClass]="{'sort-both': column.sort === 'none','sort-asc': column.sort === 'sort-asc', 'sort-desc': column.sort === 'sort-desc'}">
                        {{column.name}}</div>
                      </th>
                    }
                  }
                </tr>
              }
            </thead>
            <tbody>
              <!-- | sort : [sortparam,sortDirection] after groups for sort -->
              @for (group of groups  | paginate: { itemsPerPage: groupPageSize, currentPage: page } | search: searchText | sort: sortField:sortDirection; track group; let i = $index) {
                <tr
                  >
                  @if (groupData.columns[0].selected) {
                    <td
                      [ngClass]="{'color-green': group.status === 'Active','color-red': group.status === 'Pending','color-orange': group.status === 'Ready'}">
                    {{group.status}}</td>
                  }
                  @if (groupData.columns[1].selected) {
                    <td class="selectable"><i
                      class="fa fa-object-group group-icon"></i><span>{{group.name}}</span></td>
                    }
                    @if (groupData.columns[2].selected) {
                      <td class="selectable">{{group.id}}</td>
                    }
                    @if (groupData.columns[3].selected) {
                      <td><a
                      href="mailto:{{group.owner.email}}">{{group.owner.name}}</a></td>
                    }
                    @if (groupData.columns[4].selected) {
                      <td>
                        <div class="btn-group btn-devices" uib-dropdown="uib-dropdown" auto-close="outsideClick">
                          <button class="btn-ln btn btn-sm btn-primary-outline btn-devices" type="button"
                            [disabled]="!group.devices.length"
                            (click)="this.devicesShow=true; this.usersShow=false; initGroupDevices(group); $event.stopPropagation();"
                            uib-dropdown-toggle="uib-dropdown-toggle">
                            <span>{{group.devices.length}}</span>
                          </button>
                          @if (scopeGroupsEnv[group.id].deviceCurrentPage && scopeGroupsEnv[group.id].devices.length && showDevice && activeGroupId === group.id && !activeTab && devicesShow) {
                            <ul class="dropdown-menu group-devices mt-3"
                              uib-dropdown-menu="uib-dropdown-menu" role="menu" (click)="$event.stopPropagation()">
                              <li style="padding: 1em;">
                                <a>
                                  <app-pagination [totalItems]="group.devices.length"
                                    [itemsPerPage]="groupDevicesPageSize" [itemsSearch]="deviceSearchText"
                                    (searchedData)="onSearchDevice($event)"
                                    (itemPerPageData)="onDevicesItemPerPageChange($event)"
                                    (nextPageChange)="onNextPageChangeDevices($event)">
                                  </app-pagination>
                                  <form class="form-inline">
                                    <div class="form-group">
                                    </div>
                                  </form>
                                </a>
                              </li>
                              <!-- | pagedObjectsFilter:scopeGroupsEnv[group.id]:'deviceCurrentPage':'deviceItemsPerPage':'filteredDevices' -->
                              @for (device of scopeGroupsEnv[group.id].devices | paginate: { itemsPerPage: groupDevicesPageSize, currentPage: devicesPage } | search: deviceSearchText ; track device) {
                                <li
                                  >
                                  <div class="device-line"><i class="fa fa-mobile group-device-icon"></i>
                                  <div class="group-device-details selectable"><a
                                    class="group-device-name">{{device.manufacturer + ' ' + device.model + ' (' +
                                  device.marketName + ')'}}</a>
                                  <!-- <span>{{': ' + device.ios ? this.device.display.height : device.display + 'x' + device.ios ? this.device.display.width : device.display + ' - '}}</span> -->
                                  <div class="group-device-id"><span>Serial</span><span>{{': ' + device.serial + ' -
                                  '}}</span><span>OS </span><span>{{': ' + device.version + ' -
                                  '}}</span><span>SDK</span><span>{{': ' + device.sdk}}</span>
                                </div>
                              </div>
                            </div>
                          </li>
                        }
                      </ul>
                    }
                  </div>
                </td>
              }
              @if (groupData.columns[5].selected) {
                <td>
                  <div class="btn-group btn-users">
                    <button class="btn-ln btn btn-sm btn-primary-outline btn-users" type="button"
                      [disabled]="!group.users.length"
                      (click)="this.usersShow=true; this.devicesShow=false; initGroupUsers(group); $event.stopPropagation();">
                      <span>{{group.users.length}}</span>
                    </button>
                    @if (scopeGroupsEnv[group.id].userCurrentPage && scopeGroupsEnv[group.id].users && activeGroupId === group.id && !activeTab && usersShow) {
                      <ul class="dropdown-menu group-users mt-3"
                        uib-dropdown-menu="uib-dropdown-menu" role="menu" (click)="$event.stopPropagation()">
                        <li>
                          <div class="user-line">
                            <form style="float:inline-end">
                              <div class="form-group mailto">
                                <button style="--bs-btn-hover-bg: #d3d4d5; margin-left: 50px;"
                                  class="btn btn-xs btn-primary-outline pull-right mail-btn" type="button"
                                  data-bs-toggle="tooltip" data-bs-placement="top"
                                  title="Write an email to the group user selection." (click)="mail()">
                                  <i class="fa fa-envelope-o p-1"></i>
                                  <span>{{"Contact Users" | translate}}</span>
                                </button>
                                <!-- [disabled]="scopeGroupsEnv[group.id].filteredUsers" (click)="mailToGroupUsers(group, scopeGroupsEnv[group.id].filteredUsers)" -->
                              </div>
                            </form>
                            <form class="form-inline">
                              <div class="form-group">
                                <app-pagination [totalItems]="group.users.length"
                                  [itemsPerPage]="groupUsersPageSize" [itemsSearch]="userSearchText"
                                  (searchedData)="onSearchUser($event)"
                                  (itemPerPageData)="onUsersItemPerPageChange($event)"
                                  (nextPageChange)="onNextPageChangeUsers($event)">
                                </app-pagination>
                              </div>
                            </form>
                          </div>
                        </li>
                        @for (user of scopeGroupsEnv[group.id].users | paginate: { itemsPerPage: groupUsersPageSize, currentPage: usersPage } | search: userSearchText ; track user) {
                          <li
                            >
                            <div class="user-line"><i class="fa fa-user group-user-icon"></i>
                            <div class="group-user-details selectable"><a class="group-user-name"
                            href="mailto:{{user.email}}">{{user.name}}</a>
                            <div class="group-user-id">
                              <span>Email</span><span>{{': ' + user.email + ' -
                              '}}</span><span>Privilege</span><span>{{': ' + user.privilege}}</span>
                            </div>
                          </div>
                        </div>
                      </li>
                    }
                  </ul>
                }
              </div>
            </td>
          }
          @if (groupData.columns[6].selected) {
            <td>{{getClassName(group.class)}}</td>
          }
          @if (groupData.columns[7].selected) {
            <td>{{group.repetitions}}</td>
          }
          @if (groupData.columns[8].selected) {
            <td>{{getDuration(group.duration)}}</td>
          }
          @if (groupData.columns[9].selected) {
            <td>{{group.startTime}}</td>
          }
          @if (groupData.columns[10].selected) {
            <td>{{group.stopTime}}</td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>